import HtmlElement from './HtmlElement';
import {$window} from "../Constants";

/**
 * ScrollingText
 *
 * @return Array
 */
const ScrollingText = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		SCROLLING_TEXT: '.scrolling-text'
	};

	/**
	 * ScrollingText
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class ScrollingText extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			const viewportHeight = window.innerHeight;

			const calculateProgress = () => {
				const rect = this.$element.get(0).getBoundingClientRect();
				const padding = 150;
				let progress;

				if (rect.top >= viewportHeight) {
					progress = 0;
				} else if (rect.bottom <= 0) {
					progress = 1;
				} else {
					const totalScrollableDistance = viewportHeight - rect.height + padding;
					const scrollPosition = viewportHeight - rect.top;
					progress = scrollPosition / totalScrollableDistance;
					progress = Math.max(0, Math.min(1, progress));
				}

				return progress;
			};

			const MAX_OFFSET = $window.width() >= 640 ? 150 : 300;

			const applyTranslateX = ()  => {
				const progress = calculateProgress();
				const translateX = -MAX_OFFSET + progress * -MAX_OFFSET * 2;
				this.$element.get(0).style.setProperty('--marquee-x', `${translateX}px`);
			};

			applyTranslateX();

			document.addEventListener('scroll', () => {
				applyTranslateX();
			});
		}
	}

	return ScrollingText._getElements(Selector.SCROLLING_TEXT, ScrollingText);
})();

export default ScrollingText;
